import React from 'react';
import { useInternationalization } from '../../features/i18n';

const RequiredLabel = () => {
  const { language } = useInternationalization()
  const label = language.name === 'en' ? 'Required' : 'Wajib'

  return (
    <span className="text-error-text">*{label}</span>
  )
}

export { RequiredLabel }
